"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.normaliseSoundCues = exports.isCueDue = exports.resolveCueFireAtMs = exports.parseTimerState = exports.normalizeGuestAdventureCreateOptions = exports.normalizeGuestAdventureVariables = exports.InMemoryGuestAdventureService = exports.validateSetSharedVariableArgs = exports.InMemorySharedVariablesService = exports.isGeneralAnalyticsFeedbackRow = exports.VariableStore = exports.AdventureManager = exports.formatFriendlyDateTime = exports.RichTextParser = exports.AdventureStat = exports.AdventureItem = exports.AdventureScene = exports.AdventureHeader = exports.Option = exports.Scene = exports.GameSession = exports.Player = void 0;
exports.createGameSession = createGameSession;
exports.createGameEngine = createGameEngine;
// Main entry point for the CoopAdventureEngine
__exportStar(require("./types"), exports);
__exportStar(require("./activities"), exports);
__exportStar(require("./entities"), exports);
var models_1 = require("./models");
Object.defineProperty(exports, "Player", { enumerable: true, get: function () { return models_1.Player; } });
Object.defineProperty(exports, "GameSession", { enumerable: true, get: function () { return models_1.GameSession; } });
Object.defineProperty(exports, "Scene", { enumerable: true, get: function () { return models_1.Scene; } });
Object.defineProperty(exports, "Option", { enumerable: true, get: function () { return models_1.Option; } });
Object.defineProperty(exports, "AdventureHeader", { enumerable: true, get: function () { return models_1.AdventureHeader; } });
Object.defineProperty(exports, "AdventureScene", { enumerable: true, get: function () { return models_1.AdventureScene; } });
Object.defineProperty(exports, "AdventureItem", { enumerable: true, get: function () { return models_1.AdventureItem; } });
Object.defineProperty(exports, "AdventureStat", { enumerable: true, get: function () { return models_1.AdventureStat; } });
__exportStar(require("./parser"), exports);
// Explicit named export so Vite/Rollup production builds can resolve this
// CommonJS re-export (export * → __exportStar is not statically detectable).
var parser_1 = require("./parser");
Object.defineProperty(exports, "RichTextParser", { enumerable: true, get: function () { return parser_1.RichTextParser; } });
__exportStar(require("./engine"), exports);
__exportStar(require("./utils"), exports);
var dateTime_1 = require("./utils/dateTime");
Object.defineProperty(exports, "formatFriendlyDateTime", { enumerable: true, get: function () { return dateTime_1.formatFriendlyDateTime; } });
var AdventureManager_1 = require("./AdventureManager");
Object.defineProperty(exports, "AdventureManager", { enumerable: true, get: function () { return AdventureManager_1.AdventureManager; } });
var VariableStore_1 = require("./engine/VariableStore");
Object.defineProperty(exports, "VariableStore", { enumerable: true, get: function () { return VariableStore_1.VariableStore; } });
var AnalyticsService_1 = require("./engine/AnalyticsService");
Object.defineProperty(exports, "isGeneralAnalyticsFeedbackRow", { enumerable: true, get: function () { return AnalyticsService_1.isGeneralAnalyticsFeedbackRow; } });
var SharedVariablesService_1 = require("./engine/SharedVariablesService");
Object.defineProperty(exports, "InMemorySharedVariablesService", { enumerable: true, get: function () { return SharedVariablesService_1.InMemorySharedVariablesService; } });
Object.defineProperty(exports, "validateSetSharedVariableArgs", { enumerable: true, get: function () { return SharedVariablesService_1.validateSetSharedVariableArgs; } });
var GuestAdventureService_1 = require("./engine/GuestAdventureService");
Object.defineProperty(exports, "InMemoryGuestAdventureService", { enumerable: true, get: function () { return GuestAdventureService_1.InMemoryGuestAdventureService; } });
Object.defineProperty(exports, "normalizeGuestAdventureVariables", { enumerable: true, get: function () { return GuestAdventureService_1.normalizeGuestAdventureVariables; } });
Object.defineProperty(exports, "normalizeGuestAdventureCreateOptions", { enumerable: true, get: function () { return GuestAdventureService_1.normalizeGuestAdventureCreateOptions; } });
var TimerState_1 = require("./engine/TimerState");
Object.defineProperty(exports, "parseTimerState", { enumerable: true, get: function () { return TimerState_1.parseTimerState; } });
Object.defineProperty(exports, "resolveCueFireAtMs", { enumerable: true, get: function () { return TimerState_1.resolveCueFireAtMs; } });
Object.defineProperty(exports, "isCueDue", { enumerable: true, get: function () { return TimerState_1.isCueDue; } });
Object.defineProperty(exports, "normaliseSoundCues", { enumerable: true, get: function () { return TimerState_1.normaliseSoundCues; } });
// Export preprocessor types
__exportStar(require("./types/preprocessor"), exports);
// Export ID branded types
__exportStar(require("./types/ids"), exports);
// Convenience function to create a new game session
const AdventureManager_2 = require("./AdventureManager");
const types_1 = require("./types");
const GameSession_1 = require("./models/GameSession");
const ids_1 = require("./types/ids");
function createGameSession(adventureId, playerIds) {
    const adventureManager = AdventureManager_2.AdventureManager.getInstance();
    const adventure = adventureManager.getAdventure(adventureId);
    if (!adventure) {
        console.error(`Adventure '${adventureId}' not found`);
        return null;
    }
    // Use player definitions from adventure (now required)
    const players = playerIds.map((id, index) => {
        const playerDef = adventure.players[index];
        if (!playerDef) {
            throw new Error(`Not enough player definitions for player ${id}`);
        }
        // Find the character definition for the starting character
        const character = adventure.characters.find(c => c.name === playerDef.startingCharacter);
        if (!character) {
            throw new Error(`Starting character '${playerDef.startingCharacter}' not found for player '${playerDef.playerName}'`);
        }
        return {
            id: ids_1.IdHelpers.toPlayerId(id),
            playerName: playerDef.playerName,
            characterName: character.name,
            currentCharacter: character.name,
            inventory: [],
            stats: [],
            sceneHistory: [],
            currentScene: character.startingScene
        };
    });
    const gameSessionData = {
        id: `session_${Date.now()}`,
        adventureId,
        players,
        locationInventories: new Map(),
        status: types_1.GameStatus.ACTIVE,
        createdAt: new Date(),
        updatedAt: new Date()
    };
    return new GameSession_1.GameSession(gameSessionData);
}
function createGameEngine(sessionId) {
    // This would typically look up the session from a session store
    // For now, we'll return null as this requires session management
    console.warn('createGameEngine requires session management - not implemented yet');
    return null;
}
//# sourceMappingURL=index.js.map